// extracted by mini-css-extract-plugin
export default {"activeBtn":"menu-icon_activeBtn__1yFQH","menuList":"menu-icon_menuList__23opo","menuPaper":"menu-icon_menuPaper__GQblm"};